import * as React from 'react';
import { RouteComponentProps, withRouter, Link } from 'react-router-dom';
import { Redirect } from 'react-router';
import axios from '../../helpers/axios';
import { Grid, Card, CardContent, CardHeader, IconButton, Button, Avatar, Menu, MenuItem, Typography, FormControl, OutlinedInput, TextField, Select, InputLabel, Box, Chip, Checkbox, ListItemText, Backdrop, CircularProgress, Autocomplete, Divider, CardActions } from '@mui/material';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { withTranslation, WithTranslation } from 'react-i18next';
import OperationsHeader from './OperationsHeader';
import { DataGrid, GridRowParams, GridActionsCellItem, GridCellParams } from '@mui/x-data-grid';
import { EditOutlined, Add, Security as SecurityIcon, FileCopy as FileCopyIcon, KeyboardArrowLeftRounded, MoreHorizOutlined, CloseOutlined } from '@mui/icons-material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import { formatDate } from '../../helpers/custom';

export interface IProps {
    user: {
        id: number;
        name: string;
        email: string;
        role: string;
        is_active: boolean;
        selectedHierarchies: any[];
        selectedHierarchyIds: any[];
    };
}

export interface IState {
    showLoader: boolean;
    listOfBarcode: any;
}

class DeleteSets extends React.Component<RouteComponentProps<any> & IProps & WithTranslation, IState> {
    constructor(props: RouteComponentProps & IProps & WithTranslation) {
        super(props);
        this.state = {
            showLoader: false,
            listOfBarcode: '',
        }
    }
    public componentDidMount(): void {
        // axios.get(`routes`).then(response => {
        //     this.setState({ routes: response.data.data })
        // });
        // this.fetchCommunities();
    }

    public deleteBarcodesPermanently() {
        this.setState({ showLoader: true });
        let data = {
          "barcodes": this.state.listOfBarcode.split(","),
          "hierarchies": this.props.user.selectedHierarchyIds
        }
        axios.post('delete-barcodes-permanently', data, { headers: { 'Content-Type': 'application/json' } }).then((response: any) => {
          if (response.data.success) {
            this.setState({ showLoader: false, listOfBarcode: '' });
            toast.success(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored"
            })
          } else {
            this.setState({ showLoader: false, listOfBarcode: '' });
            toast.error(response.data.msg, {
              position: "top-right",
              autoClose: 3000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored"
            });
            let errors = response.data.errors;
            for (var error in errors) {
              toast.error(errors[error][0], {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored"
              });
            }
          }
        })
      }


    public render() {
        if (!localStorage.getItem('token')) {
            return (
                <Redirect to="/login" />
            );
        }
        const { t } = this.props;


        return (
            <div>
                <Backdrop
                    sx={{ zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                    open={this.state.showLoader}
                // onClick={() => this.setState({ showLoader: false })}
                >
                    <CircularProgress className='customLoader' />
                </Backdrop>
                <ToastContainer
                    position="top-right"
                    autoClose={5000}
                    hideProgressBar={false}
                    newestOnTop={true}
                    closeOnClick
                    rtl={false}
                    pauseOnFocusLoss
                    draggable
                    pauseOnHover
                />
                <OperationsHeader />
                <Grid container spacing={2}>
                    <Grid item md={12} xs={12} className="mt-3">
                        <Card>
                            <CardHeader
                                title={
                                    <Grid container spacing={2} >
                                        <Grid item md={3} xs={12}>
                                            <Typography variant='h5' className='MuiCardHeader-title' sx={{ lineHeight: "40px" }}>{t("Delete Bags Permanently")}</Typography>
                                        </Grid>
                                        <Grid item md={6} xs={6}>
                                            <TextField
                                                id="agent-name-input"
                                                label="Barcode"
                                                value={this.state.listOfBarcode}
                                                onChange={(e: any) => this.setState({ listOfBarcode: e.target.value })}
                                                fullWidth={true}
                                                multiline={true}
                                            />
                                        </Grid>
                                    </Grid>
                                }
                                className="text-left"
                                action={
                                    <CardActions>
                                        <Button size="large" variant='contained' sx={{ outline: 'none !important' }} onClick={() => this.deleteBarcodesPermanently()}>Delete</Button>
                                    </CardActions>
                                    // <Grid container spacing={2} justifyContent="center" alignItems="center" textAlign="left">
                                    //     <Grid item md={6} xs={6} sx={{alignSelf: 'left'}}>
                                    //         <TextField
                                    //             id="agent-name-input"
                                    //             label="Barcode"
                                    //             value={this.state.listOfBarcode}
                                    //             onChange={(e: any) => this.setState({ listOfBarcode: e.target.value })}
                                    //             fullWidth={true}
                                    //             multiline={true}
                                    //         />
                                    //     </Grid>
                                    //     <Grid item md={3} xs={3}>
                                    //     </Grid>
                                    // </Grid>
                                }
                            />
                        </Card>
                    </Grid>
                </Grid>
            </div>
        )
    }
}

export default withRouter(withTranslation()(DeleteSets))